const React = require('react');
const cx = require('classnames');
const Toggle = require('react-toggle').default;

class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked
        };
    }
    componentDidUpdate(prevProps) {
        if (this.state.checked !== this.props.checked) {
            this.setState({ checked: this.props.checked });
        }
    }
    handleChange(e) {
        this.setState({ checked: e.target.checked }, () => {
            this.props.onChange(this.state.checked);
        });
    }
    render() {
        const { block, error, noForm, labelPos } = this.props;
        const { checked } = this.state;
        // use label itself as ID (sanitized)
        const label = this.props.label || '';
        const disabled = this.props.disabled || false;
        const id = this.props.id || 'id_checkbox_'+label.replace(/[^A-Za-z0-9-_]/g, '');
        let checkedValue = false;
        if (typeof checked != 'string' && typeof checked != 'boolean' && typeof checked != 'number') {
            checkedValue = false;
        } else if (typeof checked == 'string' && checked === '1') {
            checkedValue = true;
        } else if (typeof checked == 'number' && checked == 1) {
            checkedValue = true;
        } else if (typeof checked == 'string' && checked === '0') {
            checkedValue = false;
        } else if (typeof checked == 'boolean') {
            checkedValue = checked;
        }
        const toogle = <Toggle
            id={ id }
            checked={ checkedValue }
            onChange={ this.handleChange.bind(this) }
            disabled = { disabled }
        />

        if (noForm) {
            return (toogle)
        } else {
            return (
                <div className={cx('form-group', {'has-error': !!error})}>
                    {label && (labelPos === "right"  || <label className={cx('control-label', {'': !block})} htmlFor={id}>{label}</label>)}
                    <div className={cx('checkbox', {'': !block})}>
                        {toogle}
                        {labelPos === "right"  && <label htmlFor={id}>{label}</label>}
                        {error
                            ? <span className='help-block'>{error}</span>
                            : null}
                    </div>
                </div>
            );
        }
    }
};

export default Checkbox;
